import { useCourseSidebarData } from 'components/Editor/cource/controls/CourseSidebar/context/selectors'
import { t } from 'services/Translation'

import { StructureItemCourse } from '../StructureItemCourse'
import * as s from './StructureSearch.module.scss'
import ResultItemStyled from './styled/ResultItemStyled'

interface ISearchResultProps {
  searchValue: string
  onSelect: (sectionId: string) => void
}

const StructureSearchResult = ({ searchValue, onSelect }: ISearchResultProps) => {
  const { sections, getDisabledSection } = useCourseSidebarData()
  const resultSections = sections.filter(
    (e) => !e.isChapter && e.name?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()),
  )

  return (
    <div>
      <div className={s.title}>
        {t('input.label.result')}
        <span className={s.searchNum}>{resultSections.length}</span>
      </div>
      <div className={s.resultsContent}>
        {resultSections.map((item) => {
          const disabled = getDisabledSection(item.id)
          return (
            <ResultItemStyled
              $disabled={disabled}
              key={item.id}
              onClick={() => onSelect(item.id)}
              tabIndex={disabled ? -1 : 0}
            >
              <StructureItemCourse item={item} searchValue={searchValue} />
            </ResultItemStyled>
          )
        })}
      </div>
    </div>
  )
}

export default StructureSearchResult
